import { render, staticRenderFns } from "./SupervisorReservation.vue?vue&type=template&id=2a6c6d7c"
import script from "./SupervisorReservation.vue?vue&type=script&lang=js"
export * from "./SupervisorReservation.vue?vue&type=script&lang=js"
import style0 from "./SupervisorReservation.vue?vue&type=style&index=0&id=2a6c6d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports